import React, { Component } from 'react';

import clientsA from '../resources/img/client-logo-desktop_a.png';
import clientsB from '../resources/img/client-logo-desktop_b.png';

import './Clients.css';

class Clients extends Component {
    render() {
        return (
            <div className="col-md-12 clients-bar">
                <img src={clientsA} alt="client-logos" role="presentation" />
                <img src={clientsB} alt="client-logos" role="presentation" />
            </div>
        )
    }
}

export default Clients;



// WEBPACK FOOTER //
// ./src/components/Clients.js